import script from "./Company.vue?vue&type=script&setup=true&lang=js"
export * from "./Company.vue?vue&type=script&setup=true&lang=js"

import "./Company.vue?vue&type=style&index=0&id=5b919887&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b919887"]])

export default __exports__